import React from "react";
import "./PortfolioDetailCard.scss";
import { map, isEmpty } from "lodash";
import { portfolioMetadataMap } from "utils/individualPortfolioHelper";
import { formatPercentage } from "utils/number";
import "./PortfolioDetailCard.scss";

import { Card, Col, Row } from "react-bootstrap";

interface PortfolioAsset {
  id?: string;
  symbol?: string;
  allocation?: number;
  assets?: string;
}

interface Portfolio {
  name?: string;
  label?: string;
  description?: string;
  portfolioName?: string;
  assets?: PortfolioAsset[];
}

interface PortfolioMetadata {
  label?: string;
  risk?: string;
  portfolio?: string;
  stock?: string;
  bond?: string;
  description?: string;
  key?: string;
}

interface Props {
  portfolio?: Portfolio;
  isSelected?: boolean;
  onSelect?: (...args: unknown[]) => void;
  isRecommendedPortoflio?: boolean;
}

const RecommendedPortfolio = ({
  portfolio = {},
  isRecommendedPortoflio,
}: Props) => {
  const { assets, portfolioName } = portfolio;

  const portfolioMetadata = portfolioMetadataMap[
    portfolioName as keyof typeof portfolioMetadataMap
  ] as PortfolioMetadata;

  if (isEmpty(portfolio) || isEmpty(portfolioMetadata)) return null;

  return (
    <div className="portfolio-card">
      <Card className="portfolio-detail">
        <Card.Body style={{ padding: 30 }}>
          <Card.Title className="card-title-horizontal">
            <div className="portfolio-type">
              <p className="card-label"> {portfolioMetadata.portfolio}</p>
              <p className="portfolio">Portfolio</p>
            </div>

            {isRecommendedPortoflio && (
              <div className="recommended">
                <p className="isPreferred">{" Recommended"}</p>
              </div>
            )}
          </Card.Title>
          <div className="card-description">
            <p className="stock-bond-allocation">
              {portfolioMetadata.stock}
              {portfolioMetadata.stock && portfolioMetadata.bond && (
                <span className="divider">|</span>
              )}
              {portfolioMetadata.bond}
            </p>
            <p className="card-text">{portfolioMetadata.description}</p>
          </div>
          <div className="asset-breakdown-horizontal">Breakdown of assets</div>
          <Row className="horizontal-card">
            {map(assets, (asset) => (
              <Col md={6} key={asset.id}>
                <div className="asset-details-horizontal">
                  <div className="stock-symbol">
                    <p className="sym">{asset.symbol}</p>
                  </div>
                  <p className="asset-percentage">
                    {formatPercentage(asset.allocation as number, 0)}
                  </p>
                </div>
                <div className="allocation-bar">
                  <div
                    className="allocation-fill"
                    style={{
                      width: formatPercentage(asset.allocation as number, 0),
                    }}
                  />
                </div>
              </Col>
            ))}
          </Row>
        </Card.Body>
      </Card>
    </div>
  );
};

export default RecommendedPortfolio;
